import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const LoginButton: React.FC = () => {
  const { loginWithRedirect, isLoading } = useAuth0();

  const handleLogin = () => {
    loginWithRedirect();
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 font-sans">
      <div className="bg-white p-12 rounded-xl shadow-lg text-center max-w-md w-full">
        <div className="mb-8">
          <h2 className="text-4xl font-bold text-blue-600 mb-2">Welcome</h2>
          <div className="w-16 h-1 bg-blue-600 mx-auto rounded"></div>
        </div>
        <h1 className="text-2xl font-semibold mb-4 text-gray-900">
          OpenAI Communication Platform
        </h1>
        <p className="text-gray-500 mb-8 text-base">
          Please sign in to access your projects
        </p>
        <button
          onClick={handleLogin}
          disabled={isLoading}
          className={`w-full bg-blue-600 text-white rounded-lg px-6 py-3 text-base font-medium
            ${isLoading ? 'opacity-70 cursor-not-allowed' : 'hover:bg-blue-700 cursor-pointer'}`}
        >
          {isLoading ? 'Loading...' : 'Sign In'}
        </button>
      </div>
    </div>
  );
};

export default LoginButton; 